<template>
  <t-dialog :header="formData.id?'编辑':'添加'" v-model:visible="modelShow" :onConfirm="submitForm" :closeOnOverlayClick="false">
    <t-form :model="formData" :rules="formRules">
      <t-form-item label="分组" name="groupId">
        <t-select v-model="formData.groupId" placeholder="选择分组" style="width: 100%">
          <t-option v-for="item in groups" :key="item.id"
                     :label="item.groupName" :value="item.id"/>
        </t-select>
      </t-form-item>
      <t-form-item label="文件">
        <!--       :before-upload="handleBeforeUpload" -->
        <t-upload
            :action="baseUrl+'/file/upload?dir=imgPool'"
            v-model="files"
            :format-response="formatResponse"
            :sizeLimit="sizeLimit"
            :headers="uploadHeaders"
      
            @success="handleAvatarSuccess"
            @remove="handleRemove"
            theme="image"
            tips="请选择单张图片文件上传"
            accept="image/*"/>
      </t-form-item>
      <t-form-item label="资源名称">
        <t-input v-model="formData.imgName" placeholder="请输入资源名称"/>
      </t-form-item>
    </t-form>
  </t-dialog>
</template>

<script>
import {saveOrUpdateApi} from "@/api/img-pool";
import {listGroupAllApi} from "@/api/img-group-api";
import {baseUrl,fileUrl} from "/env";
import {getToken} from "@/utils/auth";
import {compressImage} from "@/utils/file-util";

export default {
  name: "img-pool-form",
  props:{
    groupId:String
  },
  data() {
    return {
      fileUrl,
      uploadHeaders:{'X-Token':getToken()},
      baseUrl:baseUrl,
      formData:{imgName:''},
      modelShow:false,
      formRules:{
        groupId: [
          { required: true, message: '请选择分组', trigger: 'blur' }
        ]
      },
      groups:[],
      files:[],
      sizeLimit:{size: 20, unit: 'MB', message: '图片大小不超过 {sizeLimit} MB'}
    }
  },
  methods:{
    opened(isEdit,row){
      listGroupAllApi().then(res => {
        this.groups = res.data;
        if(this.groupId){
          this.formData.groupId = this.groupId
        }
      })
      this.formData = {};
      this.files = [];
      if (isEdit){
        this.formData = row;
        this.files.push({url:this.fileUrl + row.filePath,response:{data:row.filePath}})
      }
      this.modelShow = true;
    },
    // 上传前对图片进行压缩
    async handleBeforeUpload(file) {
      if (file.type.startsWith('image/')) {
        try {
          file.raw = await compressImage(file.raw,0.1);
          return file;
        } catch (err) {
         console.log('图片压缩失败',err);
         return false;
        }
      }
    },
    submitForm(){
      if(!this.formData.groupId){
        this.$message.error('请选择分组')
        return;
      }
      if (!this.files){
        this.$message.error('请上传图片')
        return;
      }
      if (!this.formData.imgName){
        this.$message.error('请输入资源名称')
        return;
      }
      this.formData.filePath = this.files[0].response.data
      saveOrUpdateApi(this.formData).then(() => {
        this.modelShow = false;
        this.$emit('refreshTable');
      })
    },
    handleAvatarSuccess(res) {
      if (res.response.code !== 200){
        this.$message.error(res.msg)
      }else{
        this.formData.imgName = res.file.name.substr(0, res.file.name.lastIndexOf('.'));
      }
    },
    formatResponse(res){
      if (res.code !== 200) {
        return { error: '上传失败，请重试' };
      }
      return { ...res, url: this.fileUrl + res.data };
    },
    handleRemove(){
      this.files = []
    }
  }
}
</script>

<style scoped>

</style>
